import React from 'react';
import { Row, Col, FormInstance } from 'antd';
import { SearchBarInput } from './SearchBarInput';
import { SettingsButton } from './SettingsButton';
import { FilterFormSubmitValues } from '@/components/Settings/DataExtraction/ExtractionType/Hierarchy/types';

interface FilterFormProps {
	form: FormInstance;
	onSubmit: (values: FilterFormSubmitValues) => void;
	onClose: () => void;
}

export function FilterForm({ form, onSubmit, onClose }: Readonly<FilterFormProps>) {
	return (
		<Row gutter={10} align="middle">
			<Col flex="auto">
				<SearchBarInput />
			</Col>
			<Col flex="none">
				<SettingsButton 
					form={form}
					onSubmit={onSubmit} 
					onClose={onClose} 
				/>
			</Col>
		</Row>
	);
}
